import toast from 'react-hot-toast';
import { useQuery } from 'react-query';

import {
  TITVPastEventsResponse,
  TITV_PAST_EVENTS_KEY,
  fetchTITVPastEvents,
} from '@utils/backend-api/titv';

export default function useTITVPastEvents(page = 1, pageSize = 6) {
  const { data, isLoading } = useQuery<TITVPastEventsResponse>(
    [TITV_PAST_EVENTS_KEY, page, pageSize],
    () => fetchTITVPastEvents({ page, page_size: pageSize }),
    {
      onError: () => {
        console.error('Failed to load past events');
        toast.error("We couldn't load past events. Please try again later.");
      },
      keepPreviousData: true,
      retry: 1,
    }
  );

  return {
    currentPage: data?.currentPage ?? 1,
    events: data?.events ?? [],
    isLoading,
    totalPages: data?.totalPages ?? 1,
  };
}
